import React from 'react'
import {
  Users,
  ThumbsUp,
  ThumbsDown,
  CheckCircle2,
  AlertTriangle,
  Clock,
  PiggyBank,
  Brain,
  Activity
} from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

const PerfilDuenoCard = ({ perfilDueno }) => {
    if (!perfilDueno) return null;
    const { idealPara, requisitosDueno } = perfilDueno;
   
    const RequirementSection = ({ icon: Icon, title, primary, items }) => (
      <div className="bg-white p-3 rounded-lg border border-blue-50 hover:border-blue-200 transition-colors">
        <div className="flex items-start gap-2">
          <Icon className="h-5 w-5 text-blue-600 mt-0.5" />
          <div className="space-y-2">
            <p className="text-base font-medium text-blue-700">{title}</p>
            <p className="text-sm text-gray-700">{primary}</p>
            {items && (
              <div className="grid gap-1">
                {items.map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <CheckCircle2 className="h-3.5 w-3.5 text-blue-500" />
                    <span className="text-sm text-gray-600">{item}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
   
    return (
      <Card className="overflow-hidden bg-white">
        <CardHeader className="border-b bg-gradient-to-r from-fuchsia-500/10 to-transparent p-4 sm:p-5">
          <div className="flex items-center gap-3">
            <div className="p-2.5 bg-gradient-to-br from-fuchsia-500 to-fuchsia-600 rounded-lg shadow-sm">
              <Users className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
            </div>
            <div>
              <CardTitle className="text-xl sm:text-2xl font-semibold text-gray-800">
                Perfil de Dueño
              </CardTitle>
              <p className="text-base text-gray-500 mt-1">
                Conoce si esta raza encaja con tu estilo de vida
              </p>
            </div>
          </div>
        </CardHeader>
   
        <CardContent className="p-4 sm:p-5 space-y-6">
          {/* Ideal Para Section */}
          {idealPara?.length > 0 && (
            <div className="bg-gradient-to-br from-green-50 to-white rounded-lg border border-green-100 p-4 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-2 mb-3">
                <ThumbsUp className="h-5 w-5 text-green-600" />
                <h3 className="text-lg font-medium text-gray-900">Ideal para</h3>
              </div>
              <div className="grid gap-2">
                {idealPara.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-2 bg-white p-2.5 rounded-lg border border-green-50 hover:border-green-200 transition-colors">
                    <CheckCircle2 className="h-4 w-4 mt-0.5 text-green-600 flex-shrink-0" />
                    <p className="text-sm sm:text-base text-gray-700">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
   
          {/* Requisitos Section */}
          {requisitosDueno && (
            <div className="bg-gradient-to-br from-blue-50 to-white rounded-lg border border-blue-100 p-4 space-y-4">
              <div className="flex items-center gap-2">
                <Clock className="h-5 w-5 text-blue-600" />
                <h3 className="text-lg font-medium text-gray-900">Requisitos del Dueño</h3>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <RequirementSection
                  icon={Clock}
                  title="Tiempo"
                  primary={requisitosDueno.tiempo.minimo}
                  items={requisitosDueno.tiempo.actividades}
                />
                <RequirementSection
                  icon={PiggyBank}
                  title="Economía"
                  primary={requisitosDueno.economia.presupuestoMensual}
                  items={requisitosDueno.economia.gastosEspeciales}
                />
                <RequirementSection
                  icon={Brain}
                  title="Compromiso"
                  primary={requisitosDueno.compromiso.educacion}
                  items={[
                    requisitosDueno.compromiso.paciencia,
                    requisitosDueno.compromiso.dedicacion
                  ]}
                />
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    );
   };
   
   export default PerfilDuenoCard;
